import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_company_detail = _resolveComponent("company-detail")!

  return (_openBlock(), _createBlock(_component_company_detail, {
    menuTab: _ctx.menuTab,
    detail: _ctx.detail,
    buttons: _ctx.buttons,
    settings: _ctx.settings,
    nameEnAbbr: _ctx.nameEnAbbr,
    canEditBusinessDate: _ctx.canEditBusinessDate,
    canEditCurrencySystem: _ctx.canEditCurrencySystem
  }, null, 8, ["menuTab", "detail", "buttons", "settings", "nameEnAbbr", "canEditBusinessDate", "canEditCurrencySystem"]))
}